<template>
    <div class="box">
        <el-form label-width="auto">

            <SectionTitle title="基础信息" />
            <el-form-item label="标题">
                <el-input v-model="myObj.bottom_list_wallpaper_params.title" placeholder="请输入"></el-input>
            </el-form-item>

            <SectionTitle title="数据选择" />
            <el-form-item label="大栏目">
                <el-autocomplete clearable v-model="queryCategory" :fetch-suggestions="querySearchCategory"
                    placeholder="搜索/选择大栏目" @select="(item) => handleSelectCategory(item)"></el-autocomplete>
            </el-form-item>
            <el-form-item label="图片标签">
                <el-autocomplete clearable v-model="queryTag" :fetch-suggestions="querySearchTag"
                    placeholder="搜索/选择图片标签" @select="(item) => handleSelectTag(item)"></el-autocomplete>
            </el-form-item>
            <el-form-item label="每页个数">
                <el-input-number v-model="myObj.source_list.params.per_page" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="排序">
                <el-radio-group v-model="myObj.source_list.params.photo_order">
                    <el-radio label="newest">最新</el-radio>
                    <el-radio label="hot">最热</el-radio>
                </el-radio-group>
            </el-form-item>

            <SectionTitle title="样式设置" />

            <el-form-item label="展示类型">
                <el-select v-model="myObj.bottom_list_wallpaper_params.show_type" placeholder="请选择">
                    <el-option v-for="item, index in showTypeOptions" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="左右间距">
                <el-input-number v-model="myObj.bottom_list_wallpaper_params.margin" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素间距">
                <el-input-number v-model="myObj.bottom_list_wallpaper_params.between_space" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素圆角">
                <el-input-number v-model="myObj.bottom_list_wallpaper_params.corner_radius" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="高度比例" v-if="myObj.bottom_list_wallpaper_params.show_type == 'photolist'">
                <el-input-number v-model="myObj.bottom_list_wallpaper_params.item_height_ratio"
                    :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="每列个数">
                <el-radio-group v-model="myObj.bottom_list_wallpaper_params.column">
                    <el-radio :label="2">2个</el-radio>
                    <el-radio :label="3">3个</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="显示点赞">
                <el-switch v-model="myObj.bottom_list_wallpaper_params.show_like" :active-value="1"
                    :inactive-value="0"></el-switch>
            </el-form-item>

            <el-form-item label="显示作者">
                <el-switch v-model="myObj.bottom_list_wallpaper_params.show_author" :active-value="1"
                    :inactive-value="0"></el-switch>
            </el-form-item>

            <el-form-item label="显示底栏">
                <el-switch v-model="myObj.bottom_list_wallpaper_params.show_bottom_view" :active-value="1"
                    :inactive-value="0"></el-switch>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import { GetAtlasCategoryList, GetAtlasTagList } from '@/request/api'

import SectionTitle from '@/components/SectionTitle.vue';
export default {
    name: "BottomListWallpaperProp",
    components: {
        SectionTitle
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            showTypeOptions: [
                { name: '图片列表样式', value: 'photolist' },
                { name: '瀑布流样式', value: 'waterfall' }],
            queryCategory: '',
            queryTag: ''
        }
    },
    mounted() {
        this.queryCategory = this.myObj.source_list.ignore.category_name
        this.queryTag = this.myObj.source_list.ignore.tag_name
    },
    methods: {
        /**
         * 查询大栏目
         */
        querySearchCategory(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasCategoryList(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.categoryID
                        }
                    })
                    cb(list)
                })
        },
        /**
        * 查询标签
        */
        querySearchTag(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasTagList(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.tagID
                        }
                    })
                    cb(list)
                })
        },
        handleSelectCategory(item) {
            this.queryStringCategory = item.value
            this.myObj.source_list.params.category_id = item.id
            //辅助回显信息
            this.myObj.source_list.ignore.category_name = item.value
        },
        handleSelectTag(item) {
            this.queryStringTag = item.value
            this.myObj.source_list.params.tag_id = item.id
            //辅助回显信息
            this.myObj.source_list.ignore.tag_name = item.value
        },
    }
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}
</style>